





import { Component, Vue } from "vue-property-decorator";
import info from "@/info";
import Formulario from "@/components/Formulario.vue";


export default class Promotion extends Vue {

  mounted() {
  }

}
